import * as THREE from "three";
import { Context } from "../core/context";
import { DbLine, DbMesh, FMathUtils, generateUUID } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  ElevationAnnotationModifyReturnData,
  InsertDatas,
  InsertFileAcceptParams,
} from "@/core/Parameters";

class InsertFileModify implements IModifyOperation {
  private m_context: Context;
  private m_locationObject: THREE.LineSegments;
  private m_returnData: ElevationAnnotationModifyReturnData = {
    basePoint: [],
    dirPoint: undefined,
    dirState: undefined,
  };
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_insertGroup!: THREE.Group;
  private m_sourceInsertGroup: THREE.Group = new THREE.Group();
  private m_insertDatas: InsertDatas = { lines: {}, meshs: {} };
  private m_sourceInsertDatas: InsertDatas = { lines: {}, meshs: {} };
  private m_insertScale: THREE.Vector3 = new THREE.Vector3(1, 1, 1);
  private m_insertAcceptCallback:
    | InsertFileAcceptParams["acceptParametersCallBack"]
    | undefined;
  private m_unifyExtendId = "";
  private m_unifyRootReferenceId = "";
  private m_isInsertManager: any = undefined;
  private m_rotate: number = 0;
  private m_insertMatrix: THREE.Matrix4 = new THREE.Matrix4();
  private m_isInsertContinuous: boolean = false;
  private m_acceptParams: InsertFileAcceptParams;
  private m_isMoveModel: boolean = true;
  private m_isFit: boolean = false;
  private m_select: DbLine | DbMesh | undefined;

  constructor(context: Context, acceptParams: InsertFileAcceptParams) {
    this.m_context = context;
    this.m_locationObject = this.m_context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    if (acceptParams.scale instanceof Object) {
      this.m_insertScale = new THREE.Vector3(
        acceptParams.scale.x,
        acceptParams.scale.y,
        acceptParams.scale.z
      );
    } else {
      this.m_insertScale = new THREE.Vector3(
        acceptParams.scale,
        acceptParams.scale,
        acceptParams.scale
      );
    }
    this.m_context.ModelManager.isInsert = true;
    this.m_isInsertContinuous = acceptParams.isInsertContinuous;
    this.m_acceptParams = acceptParams;
    this.loadInsertModel(acceptParams);
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_locationObject.position.copy(point.point.clone());
    if (this.m_isMoveModel) {
      this.m_isFit = false;
      this.m_curPoint = point.point.clone();
      let TextLabelLocation = new THREE.Vector3();
      TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 55;
      TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
      if (!this.m_acceptParams.isProhibitionRotate) {
        this.m_TextLabel.SetVaule(
          "按空格键将逆时针旋转图例90度",
          TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );
      }
      if (this.m_insertGroup) {
        let angle = 0;
        this.m_insertGroup.position.copy(this.m_curPoint);
        this.m_insertGroup.visible = true;
        if (this.m_acceptParams.fitLayerName) {
          let { obejct } = point;
          if (obejct?.length) {
            let obj = obejct[0];
            if (obj instanceof DbLine) {
              let layerName = this.m_context.ModelManager.GetLayerById(
                obj.layerId
              )?.Name;
              if (
                layerName &&
                this.m_acceptParams.fitLayerName.includes(layerName)
              ) {
                let { points } = obj;
                let startP = new THREE.Vector3(points[0], points[1], points[2]);
                let endP = new THREE.Vector3(points[3], points[4], points[5]);
                let vectorNormal = endP.clone().sub(startP).normalize();
                let xAxis = new THREE.Vector3(1, 0, 0);
                angle = vectorNormal.angleTo(xAxis);
                if (vectorNormal.clone().cross(xAxis).z > 0) {
                  angle = -angle;
                }
                console.log(angle);
                this.m_isFit = true;
              }
            }
          }
          this.fitRotateInsertModel(angle);
        }
      }
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_insertGroup) {
      if (point.obejct) {
        this.m_select = point.obejct[0] as DbLine;
      }
      if (this.m_acceptParams.fitLayerName) {
        if (this.m_isFit || this.m_acceptParams.isFitAndLibertyInsert) {
          this.endCurInsert();
        }
      } else {
        this.endCurInsert();
      }
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.code === "Space" && !this.m_acceptParams.isProhibitionRotate) {
      this.rotateInsertModel();
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    this.m_context.ModelManager.isInsert = false;
    if (operate == ModifyOperateState.complete) {
      // this.m_callback(this.m_returnData);
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_locationObject.scale.set(this.m_scale, this.m_scale, this.m_scale);
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private endCurInsert() {
    if (this.m_isInsertManager) {
      this.m_isMoveModel = false;
      this.m_isInsertManager(this.insertCallBack.bind(this));
    } else {
      this.insertCallBack();
    }
  }

  private insertCallBack() {
    this.m_isMoveModel = true;
    let insertData: (DbLine | DbMesh)[] = [];
    for (let key in this.m_insertDatas.lines) {
      let lines = this.m_insertDatas.lines[key];
      insertData.push(...lines.lines);
    }
    for (let key in this.m_insertDatas.meshs) {
      let meshs = this.m_insertDatas.meshs[key];
      insertData.push(...meshs.meshs);
    }
    let intersectModels =
      this.m_context.SelectionManager.m_raycaster.intersectObjects(
        this.m_context.SceneManager.Scene.children,
        true
      );
    this.m_unifyExtendId = generateUUID();
    this.m_unifyRootReferenceId = generateUUID();
    let zAxis = new THREE.Vector3(0, 0, 1);
    let q = new THREE.Quaternion().setFromAxisAngle(zAxis, this.m_rotate);
    let matrix = new THREE.Matrix4();
    matrix.compose(this.m_curPoint.clone(), q, this.m_insertScale);
    this.m_insertMatrix = matrix;
    this.m_rotate = 0;
    this.updatedDataModel(insertData);
    this.m_insertAcceptCallback!({
      insertData,
      intersectModels,
      matrix,
      select: this.m_select,
    });
    this.resetState();
    if (!this.m_isInsertContinuous) {
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }
  }
  private updatedDataModel(insertData: (DbLine | DbMesh)[]) {
    for (let i = 0; i < insertData.length; i++) {
      insertData[i].extend_id = this.m_unifyExtendId;
      insertData[i].root_reference_id = this.m_unifyRootReferenceId;
      let data = insertData[i];
      this.m_context.ModelManager.SetReferences(data);
      this.m_context.ModelManager.AddBlockInstance(data, this.m_insertMatrix);
      if (data instanceof DbLine) {
        let { points } = data;
        for (let j = 0; j < points.length; j += 3) {
          let point = new THREE.Vector3(
            points[j],
            points[j + 1],
            points[j + 2]
          );
          point.applyMatrix4(this.m_insertMatrix);
          points[j] = point.x;
          points[j + 1] = point.y;
          points[j + 2] = point.z;
        }
      } else if (data instanceof DbMesh) {
        let { vertexs } = data;
        for (let j = 0; j < vertexs.length; j += 3) {
          let vertex = new THREE.Vector3(
            vertexs[j],
            vertexs[j + 1],
            vertexs[j + 2]
          );
          vertex.applyMatrix4(this.m_insertMatrix);
          vertexs[j] = vertex.x;
          vertexs[j + 1] = vertex.y;
          vertexs[j + 2] = vertex.z;
        }
      }
      data.getBoundingBox();
      data.getBoundingSphere();
    }
    let { Lines, Meshs } = this.m_context.ModelManager;

    for (let key in this.m_insertDatas.lines) {
      let lineData = this.m_insertDatas.lines[key];
      if (!Lines[key]) {
        Lines[key] = lineData;
        this.m_context.SceneManager.ModelLayer.add(lineData.model);
      } else {
        Lines[key].lines.push(...lineData.lines);
      }
    }
    for (let key in this.m_insertDatas.meshs) {
      let meshData = this.m_insertDatas.meshs[key];
      if (!Meshs[key]) {
        Meshs[key] = meshData;
        this.m_context.SceneManager.ModelLayer.add(meshData.model);
      } else {
        Meshs[key].meshs.push(...meshData.meshs);
      }
    }
    this.m_context.ModelManager.updateReferencesGeometry(insertData);
    let keyDatas = this.m_context.ToolsManager.filterRepeatKeyData(insertData);
    for (let i = 0; i < keyDatas.length; i++) {
      let key = keyDatas[i];
      let layerId = key.split("_")[0];
      let layer = this.m_context.ModelManager.LayerTable[layerId];
      if (Lines[key]) {
        this.m_context.ToolsManager.LinesToModel(
          Lines[key].lines,
          Lines[key].model
        );
        if (layer && !layer.Objects.includes(Lines[key].model)) {
          layer.Objects.push(Lines[key].model);
        }
      }
      if (Meshs[key]) {
        this.m_context.ToolsManager.MeshToModel(
          Meshs[key].meshs,
          Meshs[key].model
        );
        if (layer && !layer.Objects.includes(Meshs[key].model)) {
          layer.Objects.push(Meshs[key].model);
        }
      }
    }
  }

  private rotateInsertModel(rotate: number = Math.PI / 2) {
    if (this.m_insertGroup) {
      this.m_rotate += rotate;
      if (this.m_rotate >= Math.PI * 2) {
        this.m_rotate = 0;
      }
      this.m_insertGroup.rotateZ(rotate);
      this.m_context.ViewManager.Render();
    }
  }

  private loadInsertModel(
    acceptParams: InsertFileAcceptParams,
    position?: THREE.Vector3
  ) {
    this.m_context.ModelManager.addInsertGroup();
    this.m_context.LoadManager.LoadBlockP2d(acceptParams.file, true, () => {
      this.m_insertGroup = this.m_context.ModelManager.InsertGroup;
      this.m_insertGroup.visible = false;
      this.m_insertGroup.scale.set(
        this.m_insertScale.x,
        this.m_insertScale.y,
        this.m_insertScale.z
      );

      this.m_insertDatas = this.m_context.ModelManager.InsertDatas;
      this.m_sourceInsertDatas = this.cloneInsertDatas(this.m_insertDatas);
      for (let i = 0; i < this.m_insertGroup.children.length; i++) {
        let cloneModel = this.m_insertGroup.children[i].clone() as THREE.Mesh;
        cloneModel.geometry = this.cloneInsertModelGeometry(
          this.m_insertGroup.children[i].clone()
        );
        this.m_sourceInsertGroup.add(cloneModel);
      }
      this.m_insertAcceptCallback = acceptParams.acceptParametersCallBack;
      this.m_isInsertManager = acceptParams.isInsertManger;
      if (position) {
        this.m_insertGroup.visible = true;
        this.m_insertGroup!.position.copy(position);
      }
    });
  }

  private resetState() {
    if (this.m_insertGroup) {
      this.m_insertGroup.removeFromParent();
      this.m_insertGroup = new THREE.Group();
      this.m_insertGroup.scale.set(
        this.m_insertScale.x,
        this.m_insertScale.y,
        this.m_insertScale.z
      );

      for (let i = 0; i < this.m_sourceInsertGroup.children.length; i++) {
        let cloneModel = this.m_sourceInsertGroup.children[
          i
        ].clone() as THREE.Mesh;
        cloneModel.geometry = this.cloneInsertModelGeometry(
          this.m_sourceInsertGroup.children[i].clone()
        );
        this.m_insertGroup.add(cloneModel);
      }
      this.m_context.ModelManager.Model.add(this.m_insertGroup);
    }
    this.m_context.ModelManager.InsertDatas = { lines: {}, meshs: {} };
    this.m_insertDatas = this.cloneInsertDatas(this.m_sourceInsertDatas);
  }

  private fitRotateInsertModel(rotate: number = 0) {
    this.m_insertGroup.rotation.set(0, 0, rotate);
    this.m_rotate = rotate;
    this.m_context.ViewManager.Render();
  }

  private cloneInsertDatas(sourceData: InsertDatas) {
    let copyDatas: InsertDatas = { lines: {}, meshs: {} };
    for (let key in sourceData.lines) {
      copyDatas.lines[key] = {
        canEdit: sourceData.lines[key].canEdit,
        model: sourceData.lines[key].model.clone(),
        lines: [],
      };
      copyDatas.lines[key].model.geometry = this.cloneInsertModelGeometry(
        sourceData.lines[key].model
      );
      for (let i = 0; i < sourceData.lines[key].lines.length; i++) {
        let line = sourceData.lines[key].lines[i];
        copyDatas.lines[key].lines.push(DbLine.clone(line));
      }
    }

    for (let key in this.m_insertDatas.meshs) {
      copyDatas.meshs[key] = {
        canEdit: sourceData.meshs[key].canEdit,
        model: this.m_insertDatas.meshs[key].model,
        meshs: [],
      };

      copyDatas.meshs[key].model.geometry = this.cloneInsertModelGeometry(
        sourceData.meshs[key].model
      );

      for (let i = 0; i < sourceData.meshs[key].meshs.length; i++) {
        let mesh = sourceData.meshs[key].meshs[i];
        copyDatas.meshs[key].meshs.push(DbMesh.clone(mesh));
      }
    }
    return copyDatas;
  }

  private cloneInsertModelGeometry(model: THREE.Object3D) {
    let sourceGeometryPositions = (model as THREE.Mesh).geometry.attributes
      .position.array;
    let sourceGeometryIndex = (model as THREE.Mesh).geometry.index;
    let copyGeometry = new THREE.BufferGeometry();
    copyGeometry.setAttribute(
      "position",
      new THREE.BufferAttribute(new Float32Array(sourceGeometryPositions), 3)
    );
    if (sourceGeometryIndex) {
      copyGeometry.setIndex(sourceGeometryIndex);
    }
    return copyGeometry;
  }
  private clear() {
    this.m_context.ModelManager.InsertBlocks = new Map();
    this.m_context.ToolsManager.GroupClear(this.m_insertGroup);
    this.m_context.ToolsManager.GroupClear(this.m_sourceInsertGroup);
    this.m_context.ToolsManager.ObjectsClear([this.m_locationObject]);
    this.m_TextLabel?.dispose();
    this.m_context.ModelManager.InsertDatas = { lines: {}, meshs: {} };
  }
}

export { InsertFileModify };
